import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { ValidatedInput, FormGroup } from "../ui/validated-input";
import { Users, Clock, FileText } from "lucide-react";

const CompanyHRCard = ({ getFieldProps, isEditing, isValidating }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader className="pb-5">
        <CardTitle className="flex items-center gap-2.5 text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>
          <div className="p-1.5 rounded-md" style={{ backgroundColor: "rgba(245,158,11,0.10)" }}>
            <Users className="h-4 w-4" style={{ color: "#f59e0b" }} />
          </div>
          <span>{t("companyConfig.sections.hrSettings")}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <FormGroup>
          <ValidatedInput
            {...getFieldProps("legal_weekly_hours")}
            id="legal_weekly_hours"
            label={t("companyConfig.labels.workingHours")}
            type="number"
            min="30"
            max="60"
            disabled={!isEditing}
            icon={Clock}
            helpText={t("companyConfig.help.workingHours")}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <ValidatedInput
            {...getFieldProps("annual_leave_days")}
            id="annual_leave_days"
            label={t("companyConfig.labels.annualLeaveDays")}
            type="number"
            min="20"
            max="50"
            disabled={!isEditing}
            helpText={t("companyConfig.help.annualLeaveDays")}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <div className="p-6 bg-primary/5 rounded-xl border border-primary/20">
            <div className="flex items-start space-x-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <FileText className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground mb-2">{t("companyConfig.info.title")}</h4>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t("companyConfig.info.description")}
                </p>
              </div>
            </div>
          </div>
        </FormGroup>
      </CardContent>
    </Card>
  );
};

export default CompanyHRCard;
